module.exports = __webpack_public_path__ + "img/s6.3904e17.png";